import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = {
  class: "gfu-field__label gfu-field__label--big gfu-grid__cell gfu-1of2 gfu-1of2--m gfu-1of3--l _tal",
  "data-qa": "label"
}
const _hoisted_3 = {
  class: "gfu-field__value gfu-field__value--big gfu-grid__cell gfu-1of2 gfu-1of2--m gfu-2of3--l _tal",
  "data-qa": "value"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.addressFields, (field) => {
      return (_openBlock(), _createElementBlock("div", {
        key: field.dataQa,
        class: "gfu-grid gfu-grid--small",
        "data-qa": field.dataQa
      }, [
        _createElementVNode("label", _hoisted_2, _toDisplayString(field.label), 1 /* TEXT */),
        _createElementVNode("label", _hoisted_3, _toDisplayString(field.value), 1 /* TEXT */)
      ], 8 /* PROPS */, _hoisted_1))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}